export default __webpack_public_path__ + "static/media/nft-1.aead3d7a.gif";